module.exports = __webpack_public_path__ + "img/selo1.41efdf8a.png";